import type { FaireProductEntity } from "../../entity_types/product";

export const p_997zfaxbh7: FaireProductEntity = {
  token: "p_997zfaxbh7",
  type: "product",
  name: "White Tea and Jasmine 4.6 oz Bath Bomb",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/cb013f6282931d7f54ef95b8da2b0a7ecb24b4a68b0f47d750e98d66fafcfce0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ade21db5cda9cfcf9e22be4cf9060dd2a751d64ae414e302a9be44c7cf1fc96.jpeg",
    "https://cdn.faire.com/fastly/41f55e01fdd5ce871636b528417194d49525ae6170972eeebf5c676a9d164578.png",
    "https://cdn.faire.com/fastly/354bd8ec6e16a38dcfe84cbcb0aa0bcfd3826957558b472760de1af4312e0a11.png",
    "https://cdn.faire.com/fastly/027db47f857bc04d208d9af616d41bbb1b73d3ee0004f54e1087e45398bf1510.png",
    "https://cdn.faire.com/fastly/c0ac5ea7951e33c39202cbdc3e9936e035c999847eadf5c8d84f2006e74313fd.png",
    "https://cdn.faire.com/fastly/3653e37c60c66e65897ec03bda7413a1557c93bea0cb209ecc61862431dda5d8.jpeg",
    "https://cdn.faire.com/fastly/1c7f132f8e8ea45919f41f90a0d6400001e1e79bb06515ffd0ce1f7d91fc9914.png",
    "https://cdn.faire.com/fastly/151b006f764e57c45ef35d2871a766aee0df81f412ddc7fb9ad7d739e8494f55.png",
    "https://cdn.faire.com/fastly/eee7553f9e618d586796c16e7fb73dbfa9004b70d9fbf92bbee9bc4a7aae752f.png",
  ],
  priceDollars: 7.5,
  description:
    '*NOT ON AMAZON*\n\nIndulge in a moment of calm with our clean, handcrafted bath bombs made with premium fragrance oils and skin-loving ingredients. Designed to complement our best-selling products, they bring Sweet Water Decor’s signature scents to the bath for the ultimate at-home self-care experience.\n\nOur bath bombs are individually boxed and wrapped in shrink wrap and tissue paper, making them perfectably giftable.\n\nSCENT NOTES:\n• Top: Mandarin\n• Middle: Ginger\n• Base: Jasmine, White Tea\n\nInfused with natural essential oils: citrus aurantium bergamia (bergamot) fruit, litsea cubeba fruit, zingiber officinale (ginger) root\n\nBATH BOMB INFO:\n• Net Weight: 4.6 oz\n• Bath Bomb Size: 2.5" in diameter\n• Box Size: 3" x 3"\n• Gift Box\n• Non-Toxic, Free of Harsh Chemicals, Vegan\n• Premium Fragrance Oils\n• Handcrafted in the USA\n• Style No. BB070\n\nCATEGORIES:\nBath Bomb, Spring, Summer, Self Care, Gifts, Home Decor, Bath Accessories, Handcrafted Bath Bomb, Stocking Stuffers',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:18.455Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
